import React from "react";
import { DxToggle } from "genesys-react-components";
import { GenesysDevIcons } from "genesys-dev-icons";
import "../App.css";
import Orgs from "./Orgs";

const LeftPanel = ({
  darkThemeEnabled,
  setDarkThemeEnabled,
  authenticate,
  setAuthenticate,
}) => {

  return (
    <div className="left-panel">
      <DxToggle
        className="theme-toggle"
        value={darkThemeEnabled}
        falseIcon={GenesysDevIcons.AppSun}
        trueIcon={GenesysDevIcons.AppMoon}
        onChange={(value) => setDarkThemeEnabled(value === true)}
      />
      <Orgs authenticate={authenticate} setAuthenticate={setAuthenticate} />
    </div>
  );
};

export default LeftPanel;
